@if (self$ | async; as self) {
	@if (params$ | async; as params) {
		@if (params.get("smode") !== "compare" && $any(self).isNewValidVersion && visible) {
			<article [class.mobile]="(layoutService.breakpoint | async)?.isSmall" class="card" @inOut>
				<div class="label">
					<h3
						translate="process.notification.new.valid.version.message"
						[translateParams]="{
							previous: $any(self).previousValidVersionDisplayName,
							current: $any(self).versionDisplayName,
						}"
					></h3>
					<div class="buttons">
						<button
							(click)="open($any(self).previousValidVersionIdentifier, $any(self).previousValidVersionDiffValid)"
							translate="process.notification.new.valid.version.show"
						></button>
						<button (click)="markAsSeen(self.id)" translate="process.notification.new.valid.version.seen"></button>
					</div>
				</div>
			</article>
		}
	}
}
